export enum Mode {
    Light = 'light',
    Dark = 'dark',
}
